import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { useLoginStates } from '@/hooks';

import { useIsUpdateProfileEnabled } from '../use-is-update-profile-enabled';

export const useAddUpdateProfileSuccessTrackingParam = () => {
  const [isParamAdded, setIsParamAdded] = useState<boolean>(false);
  const { isLoggedIn } = useLoginStates();
  const history = useHistory();
  const isUpdateProfileEnabled = useIsUpdateProfileEnabled();
  const trackingParam = `?sc_o=${isUpdateProfileEnabled ? 'jobs_new_cv_selected' : 'jobs_no_cv_selected'}`;

  useEffect(() => {
    if (!isParamAdded && isLoggedIn) {
      history.replace({ search: trackingParam });
      setIsParamAdded(true);
    }
  }, [history, isLoggedIn, isParamAdded, trackingParam]);
};
